/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from './i18n'

// import "./registerServiceWorker";

import "./plugins/index";

import CardLoadingTransparent from "./components/shared/CardLoadingTransparent";
import CardLoading from "./components/shared/CardLoading";
import DialogLoading from "./components/shared/DialogLoading";
import DialogShowFile from "./components/shared/DialogShowFile";
import SelectDateFilter from "./components/shared/filter_date/SelectDateFilter";
import PageHeader from "./components/shared/PageHeader.vue"
import YearPicker from "./components/shared/YearPicker"
import DefaultCard from "./components/shared/DefaultCard"

Vue.component('year-picker', YearPicker);
Vue.component("page-header", PageHeader);
Vue.component("dialog-loading", DialogLoading);
Vue.component("dialog-show-file", DialogShowFile);
Vue.component("card-loading", CardLoading);
Vue.component("card-loading-transparent", CardLoadingTransparent);
Vue.component("select-date-filter", SelectDateFilter);
Vue.component("default-card", DefaultCard);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
/* eslint-enable */
